import { useState } from 'react';
import queryString from 'query-string';
import LocationListingContext, {
    type LocationListingContextProps,
    type LocationListingProps,
    type LocationListingView,
    VIEW_MAP,
    VIEW_LISTING
} from './LocationListingContext';
import { type ActiveFilter } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { getActiveFiltersFromURL, getPageFromURL } from '3-components/ListingApp/ListingFilters/ListingFilterHelpers';


interface LocationListingProviderProps extends LocationListingProps {
    children: React.ReactNode;
}

const LocationListingProvider = (props: LocationListingProviderProps): JSX.Element => {
    const { children, map, listing, ...assetsListingProps } = props;

    const initialView = queryString.parse(window.location.search).view as LocationListingView || VIEW_LISTING;

    const [activeItemId, setActiveItemId] = useState<string>('');
    const [view, setView] = useState<LocationListingView>(initialView);
    const [page, setPage] = useState(getPageFromURL());

    const activeFiltersInitialValue = view === VIEW_MAP ?
        getActiveFiltersFromURL(map.filters) :
        getActiveFiltersFromURL(listing.filters);

    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(activeFiltersInitialValue);

    const providerValue: LocationListingContextProps = {
        view,
        setView,
        activeItemId,
        setActiveItemId,
        activeFilters,
        setActiveFilters,
        page,
        setPage,
        map,
        listing,
        ...assetsListingProps,
    };

    return (
        <LocationListingContext.Provider value={providerValue}>
            {children}
        </LocationListingContext.Provider>
    );
};

export default LocationListingProvider;
